import AbstractValidator from '../abstract-validator';
import AbstractValidatorOptions from '../abstract-validator-options';
import { ga4Push } from '../../../ga4/ga4-utilities';

/**
 * Reset password form validation module
 *
 * @author Kovács Tamás
 * @returns Reset password form validation module
 */
function ResetPasswordForm() {
    const formId = 'resetPasswordForm';
    const validator = AbstractValidator(formId);
    const validatorOptions = AbstractValidatorOptions();
    const modal = $('#reset-password-modal');
    let isSuccess = false;

    function init() {
        validatorOptions.focusInvalid = false;

        validator.init(
            {
                password: {
                    required: true,
                },
                password_confirmation: {
                    required: true,
                },
            },
            validatorOptions,
        );

        $(`#${formId}`)
        .on('success', (event) => {
            // Sikeres form küldés után bezárja a modalt

            ga4Push({
                event: 'change_password',
                newPassword: 'confirm',
            });
            isSuccess = true;

            $(event.currentTarget)
            .parents('.modal')
            .first()
            .modal('hide');
        });

        modal.parent().one(
            'hidden.bs.modal',
            () => {
                if (!isSuccess) {
                    ga4Push({
                        event: 'change_password',
                        newPassword: 'exit',
                    });
                }
                validator.resetForm();
            },
        );
    }

    return {
        init,
    };
}

export default ResetPasswordForm;
